import SpecificNewsPage from "./SpecificNewsPage";

export default SpecificNewsPage;
